import { UserRole } from "authentication/userrole";
import { ROUTES } from "../../routes";

interface IMenuRoute {
  name: string;
  target: string;
  allowedRoles?: Array<UserRole>;
}

const MenuRoutes: Array<IMenuRoute> = [
  { name: "Breadcrumb_Start", target: ROUTES.HOME },
  { name: "Breadcrumb_ProductionMasterData", target: ROUTES.PRODUCTS },
  {
    name: "Breadcrumb_FormulasAndFactors",
    target: ROUTES.FORMULAS_AND_FACTORS,
  },
  {
    name: "Breadcrumb_Assets",
    target: ROUTES.ASSETS,
  },
  {
    name: "Breadcrumb_Machines",
    target: ROUTES.MACHINES,
  },
  {
    name: "Breadcrumb_CheckDimensions",
    target: ROUTES.CHECK_DIMENSIONS,
  },
];

export default MenuRoutes;
